import { computed, unref } from 'vue';
import { useStore } from './store';
import {
  getUserPermissions,
  getUserRole,
} from 'dashboard/helper/permissionsHelper';

export const usePhoneNumberMask = phoneNumber => {
  const store = useStore();

  const currentUser = computed(() => store.getters.getCurrentUser);
  const currentAccountId = computed(() => store.getters.getCurrentAccountId);

  const userPermissions = computed(() =>
    getUserPermissions(currentUser.value, currentAccountId.value)
  );
  const role = computed(() =>
    getUserRole(currentUser.value, currentAccountId.value)
  );

  const canViewPhoneNumber = computed(() => {
    const perms = userPermissions.value;
    if (role.value === 'administrator') {
      return true;
    }
    return !perms.includes('view_contact_phone_number');
  });

  const maskedPhoneNumber = computed(() => {
    const phone = unref(phoneNumber);
    if (!phone) return '';
    const phoneString = String(phone);
    return canViewPhoneNumber.value
      ? phoneString
      : `${phoneString.slice(0, -4)}****`;
  });

  return { maskedPhoneNumber, canViewPhoneNumber };
};
